<template>
  <!-- global Modal -->
  <AlertComponent
    v-if="isOpenAlertModalCode"
    :code="isOpenAlertModalCode"
    :message="propsAlertModalMsg"
    @close="alertModalClose"
  />
  <GnbComponent />

  <main class="pt-7 mobile:pt-5">
    <slot></slot>
  </main>

  <FooterComponent />
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import GnbComponent from '@/components/GNB/Index.vue';
import FooterComponent from '../layout/Footer.vue';
import AlertComponent, { alertModalControl } from '@/components/modal/Alert.vue';

export default defineComponent({
  name: 'Frame',
  components: {
    GnbComponent,
    FooterComponent,
    AlertComponent,
  },
  setup: () => {
    return { ...alertModalControl() };
  },
});
</script>

<style lang="scss">
@import '@/assets/style/screens/screen.scss';
</style>
